import { Stack } from "@mui/material";

import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { MediaFilesTable } from "MusicAudio/Components/MediaFilesTable";
import { UploadMediaFileButton } from "MusicAudio/Components/UploadMediaFileButton";
import { AuthenticatedLayout } from "Shared/Layouts/AuthenticatedLayout";

export const MusicAudioPage = (): React.ReactNode => {
  const { t } = useResource();

  return (
    <AuthenticatedLayout
      title={t(Resources.Common.MusicAudio)}
      action={<UploadMediaFileButton />}
    >
      <Stack spacing={Spacing.L}>
        <MediaFilesTable />
      </Stack>
    </AuthenticatedLayout>
  );
};
